import { Cabinet } from './Cabinet';

export class CabinetNameRule {
  public name: string;
  public apply: (cabinet: Cabinet) => boolean;

  constructor(name: string, apply: (cabinet: Cabinet) => boolean) {
    this.name = name;
    this.apply = apply;
  }
}
